import React from "react";
import icon from "../../assets/droplet.png";

export default function LiquidityIcon({ size }) {
  return <img src={icon} width={size} />;
}
